import React from 'react';
import DOMPurify from 'dompurify';

/**
 * Renders sanitized HTML — the single choke point for every
 * `dangerouslySetInnerHTML` in the app.
 *
 * Trainer-authored coach notes (TipTap output) and CMS/blog content are
 * stored as HTML and rendered raw. Without sanitization a malicious
 * trainer (or a compromised CMS) could inject `<script>` or
 * event-handler attributes; combined with the auth token's presence in
 * the browser, that's an account-takeover path (audit H22). DOMPurify
 * strips scripts, on* handlers, and other dangerous markup while keeping
 * the formatting tags notes actually use (p, strong, em, ul/ol/li, a…).
 *
 * Usage:
 *   <SafeHtml html={notes} className="nutrition-coach-notes" />
 *   <SafeHtml html={cms.content} as="section" />
 *
 * Forwards arbitrary props (className, style, etc.) to the rendered
 * element; `as` overrides the wrapper tag (default `div`).
 */
export default function SafeHtml({ html, as: Tag = 'div', ...rest }) {
  const clean = DOMPurify.sanitize(html == null ? '' : String(html));
  return <Tag {...rest} dangerouslySetInnerHTML={{ __html: clean }} />;
}
